/**
 * Auslieferungszustand der Aufgabenphasen einer Bestellung - Portierung von
 * `DEFAULT_ORDER_TASK_PHASES` aus `index.html:4169-4447` (Stand 2026-08-08).
 *
 * Die Daten selbst liegen in `orderTaskPhases.json` und NICHT als TypeScript-Literal: es sind rund
 * 280 Zeilen reiner Inhalt (Aufgabentexte, Phasenbeschreibungen) ohne jede Logik, die die
 * Fachabteilung auch ohne TypeScript-Kenntnis lesen und pflegen koennen soll. Dieses Modul gibt den
 * Daten nur einen Typ und einen Namen.
 *
 * Die JSON-Datei ist mit `npm run gen:config --workspace frontend`
 * (`scripts/gen-config-json.ts`) aus dem Original erzeugt, nicht abgetippt. Nach jeder Aenderung
 * am Original dort neu erzeugen, nicht von Hand nachziehen.
 */
import rohePhasen from "./orderTaskPhases.json" with { type: "json" };

export interface OrderTaskTemplate {
  name: string;
  description: string;
}

export interface OrderTaskPhase {
  id: string;
  title: string;
  description: string;
  tasks: readonly OrderTaskTemplate[];
}

/** 6 Phasen mit zusammen 59 Aufgaben, in Anzeigereihenfolge (index.html:4169-4447). */
export const DEFAULT_ORDER_TASK_PHASES: readonly OrderTaskPhase[] = rohePhasen;
